/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

import { SIDEBAR_STORAGE } from "@advapacs/common";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { isMobile } from "react-device-detect";

export interface ISidebarState {
  expand: boolean;
  secondarySidebar: boolean;
  activeModal: boolean;
  toggleSecondarySidebar: boolean;
  unfold: boolean;
  preventLogout: boolean;
  messagePrevent?: string;
  confirmButtonPrevent?: string;
  cancelButtonPrevent?: string;
}

export const initialState: ISidebarState = {
  expand:
    localStorage.getItem(SIDEBAR_STORAGE.SIDEBAR) && !isMobile
      ? (JSON.parse(
          localStorage.getItem(SIDEBAR_STORAGE.SIDEBAR) || ""
        ) as unknown as boolean)
      : true,
  secondarySidebar: false,
  activeModal: false,
  toggleSecondarySidebar: localStorage.getItem(
    SIDEBAR_STORAGE.SECONDARY_SIDEBAR
  )
    ? (JSON.parse(
        localStorage.getItem(SIDEBAR_STORAGE.SECONDARY_SIDEBAR) || ""
      ) as unknown as boolean)
    : true,
  preventLogout: false,
  unfold: localStorage.getItem(SIDEBAR_STORAGE.UNFOLD)
    ? (JSON.parse(
        localStorage.getItem(SIDEBAR_STORAGE.UNFOLD) || ""
      ) as unknown as boolean)
    : false,
};

const sidebarSlice = createSlice({
  name: "error",
  initialState,
  reducers: {
    toggle(state, action: PayloadAction<boolean>) {
      localStorage.setItem(SIDEBAR_STORAGE.SIDEBAR, action.payload.toString());
      state.expand = action.payload;
    },
    toggleSidebarSecondary(state, action: PayloadAction<boolean>) {
      state.secondarySidebar = action.payload;
    },
    showActiveModal(state) {
      state.activeModal = true;
    },
    toggleSecondarySidebar(state, action: PayloadAction<boolean>) {
      localStorage.setItem(
        SIDEBAR_STORAGE.SECONDARY_SIDEBAR,
        action.payload.toString()
      );
      state.toggleSecondarySidebar = action.payload || false;
    },
    toggleSidebarUnfold(state, action: PayloadAction<boolean>) {
      localStorage.setItem(SIDEBAR_STORAGE.UNFOLD, action.payload.toString());
      state.unfold = action.payload;
    },
    setPreventLogout(
      state,
      action: PayloadAction<{ message?: string; value: boolean }>
    ) {
      state.preventLogout = action.payload.value;
      if (action.payload.value) {
        state.messagePrevent = action.payload.message;
      } else {
        state.messagePrevent = "";
      }
    },
  },
});

export const sidebarAction = sidebarSlice.actions;
export default sidebarSlice.reducer;
